module.exports = __webpack_public_path__ + "static/media/file-icon_.be52ebec.svg";